import TabToggleList from 'components/commons/tab-toogle-list'
import { Button, InlineError, Input } from 'avo-ui'
import icAddSquare from 'assets/images/ic-add-square.svg'
import TabToggle from 'components/commons/tab-toogle'
import UploadImage from 'components/commons/upload-image'

export const BeautyProfileItem = ({ items, setItems, onChangeItem, onAddNewItem, errorForm }) => {
    const getError = (key, index) => {
        const findError = errorForm?.items_detail?.find((i) => i?.index === index && i?.key === key)
        return findError?.message
    }

    return (
        <TabToggle
            title={'Beauty Profile Item'}
            content={
                <div className={'flex flex-col space-y-6'}>
                    {items?.map((item, index) => (
                        <TabToggleList
                            key={`beauty-profile-${index}`}
                            index={index}
                            title={`Beauty-Profile-Item-${index + 1}`}
                            content={
                                <div className={'flex space-x-16'}>
                                    <div
                                        className={`flex-1 flex-col ${(item?.image_url?.base64 || item?.image_url?.length) && 'space-y-3'}`}
                                    >
                                        <div className={'font-semibold text-blue-90 required'}>Icon Beauty Profile</div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={'!w-48 !h-48 border border-neutral-30 rounded-md'}
                                            id={`icon-beauty-profile-${index}`}
                                            value={item?.image_url?.base64 || item?.image_url}
                                            onChange={(value) =>
                                                onChangeItem({
                                                    name: 'image_url',
                                                    value,
                                                    index,
                                                })
                                            }
                                        />
                                        <InlineError className='mt-2' message={getError('image_url', index)} />
                                    </div>
                                    <div className={'flex-1 flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>
                                            Label Beauty Profile
                                        </div>
                                        <Input
                                            className={'flex-1'}
                                            name={'name'}
                                            placeholder={'Masukkan label beauty Profile'}
                                            value={item?.name}
                                            onChange={(item) => onChangeItem({ ...item, index })}
                                        />
                                        <InlineError className='mt-2' message={getError('name', index)} />
                                    </div>
                                </div>
                            }
                            items={items}
                            setItems={setItems}
                            isDisableDelete={items?.length === 1}
                            isSorting
                        />
                    ))}
                    <InlineError className='mt-2' message={errorForm?.items} />
                    <Button
                        className={'w-fit'}
                        type={'outline'}
                        icon={icAddSquare}
                        title={'Add New Item'}
                        onClick={onAddNewItem}
                    />
                </div>
            }
        />
    )
}
